<div class="main">
    <app-scrollup></app-scrollup>
    <app-header-one></app-header-one>
    <app-breadcrumb-pricing></app-breadcrumb-pricing>
    <app-pricing-one></app-pricing-one>
    <app-faq-one></app-faq-one>
    <app-footer-one></app-footer-one>
</div>